class RegisterForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.form.onsubmit = this.submit.bind(this);
  }

  submit(event) {
    event.preventDefault();
    this.clearError();
    this.toggleSuccess(false);
    const values = {
      gender: this.form.querySelector('input[name="gender"]:checked').value,
      first_name: this.form.querySelector('input[name="first_name"]').value,
      last_name: this.form.querySelector('input[name="last_name"]').value,
      password: this.form.querySelector('input[name="password"]').value,
      confirm_password: this.form.querySelector('input[name="confirm_password"]').value,
      email: this.form.querySelector('input[name="email"]').value,
      email_permission: this.form.querySelector('input[name="email_permission"]').value,
      goal: this.form.querySelector('select[name="goal"]').value,
      primeDiscountCode: this.form.dataset.discount,
    }

    const primeInput = this.form.querySelector('input[name="prime"]');
    if (primeInput) {
      values.prime = primeInput.value === 'true';
    }
    
    if (!window.authUrl || window.authUrl == '') return;

    if(values.password !== values.confirm_password){
      this.showError(this.querySelector('#register-form-errors').getAttribute('data-wrong-password'));
      return false;
    }

    this.querySelector('#register-form-submit').disabled = true;
    
    const button = event.target.querySelector('button[type="submit"]');

    button?.classList.add('loading');
    button?.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

    const requestBody = {
      "gender": values.gender,
      "firstname": values.first_name,
      "lastname": values.last_name,
      "email": values.email,
      "password": values.password,
      "email_marketing_consent": values.email_permission,
      "additional": `Training Goal:${values.goal},Gender:${values.gender}`,
      "source": "shopify",
      "language": document.querySelector('html').getAttribute('lang')
    };
  
    if (values.prime) {
      requestBody.prime = values.prime;
    }

    fetch(`${window.authUrl}/register`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+window.apiToken,
        'Access-Control-Allow-Origin': '*'
      },
      body: JSON.stringify(requestBody)
    }).then(response => {
      return response.json();
    }).then(data => {
      if (window.localStorage) {
        localStorage.setItem('goal', values.goal);
      }
      
      if (data.success) {
        this.toggleSuccess(true);
        this.form.reset();
        button?.classList.remove('loading');
        button?.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
        if (values.primeDiscountCode) {
          let items = [
            {
              'id': window.primeProduct.id,
              'quantity': 1,
              'selling_plan': window.primeProduct.sellingPlan,
            }
          ];
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ items })
          }).then(response => response.json()).then(res_json => {
            window.localStorage.setItem('prime-in-cart', res_json.items[0].key);
            fetch(`${location.origin}/discount/${values.primeDiscountCode}`).then((res) => window.location.href = '/checkout')
          }).catch((error) => {
            console.error('Error:', error);
          });
        } else {
          window.location.href = `${window.Shopify.routes.root}pages/prime-confirmation-page`;
        }
      } else {
        if (register_form_error_codes[data.status_code], button) {
          this.showError(register_form_error_codes[data.status_code], button);
        } else {
          this.showError(data.message, button);
        }
      }
    }).catch(error => {
      this.showError(error.message);
    }).finally(()=>{
      this.querySelector('#register-form-submit').disabled = false;
    });

    return false;
  }

  showError(message, button){
    const errorWrapper = this.querySelector('#register-form-errors');
    const errorText = this.querySelector('#register-form-error-message');

    errorText.innerHTML = message;
    errorWrapper.style.display = 'block';
    setTimeout(() => {
      errorWrapper.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
    }, 500);
    
    button?.classList.remove('loading');
    button?.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
  }

  clearError(){
    const errorWrapper = this.querySelector('#register-form-errors');
    const errorText = this.querySelector('#register-form-error-message');

    errorText.innerHTML = '';
    errorWrapper.style.display = 'none';
  }

  toggleSuccess(is = null, button){
    const successWrapper = this.querySelector('#register-form-success');
    if (successWrapper) {
      if (is === true || is === false) {
        if (is) {
          successWrapper.style.display = 'block'
          setTimeout(() => {
            successWrapper.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
          });
        }else{
          successWrapper.style.display = 'none'
        }
      }else{
        if (successWrapper.style.display == 'none') {
          successWrapper.style.display = 'block'
          setTimeout(() => {
            successWrapper.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
          }, 500);
        }else{
          successWrapper.style.display = 'none'
        }
      }

    }
    
    button?.classList.remove('loading');
    button?.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
  };
}

customElements.define('register-form', RegisterForm);
